import React from "react";
import useToastStore from "../../store/useToastStore";
import Toast from "./toast";

const ToastContainer = () => {
    const { toasts, dismissToast } = useToastStore();

    return (
        <div className="fixed bottom-4 left-4  flex flex-col gap-2 z-50">
            {toasts.map(toast => (
                <Toast
                    height={toast.height}
                    key={toast.id}
                    type={toast.type}
                    message={toast.message}
                    onClose={() => dismissToast(toast.id)}
                />
            ))}
        </div>
    );
};

export default ToastContainer;
